import React from "react";
import Preloader from "../helper/Preloader";


import ShopSection from "../components/ShopSection";


import ColorInit from "../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import HeaderOne from "../components/HeaderOne";
import FooterOne from "../components/FooterOne";
import BottomFooter from "../components/BottomFooter";
import ShopBanner from "../components/ShopBanner";
import ShippingOne from "../components/ShippingOne";

const ShopPage = () => {

  return (
    <>
    <HeaderOne/>
    <ShopBanner/>
      {/* ColorInit */}
      <ColorInit color={true} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color="#FA6400" />

      {/* Preloader */}
      <Preloader />

 

   

      {/* ShopSection */}
      <ShopSection />

    
      <ShippingOne/>

    <FooterOne/>
    <BottomFooter/>


    </>
  );
};

export default ShopPage;
